import { IGetOneResponse } from '../util/Types/Generic';
import { ApiService } from './ApiService';

export class PushDataService extends ApiService {
  static pathName = '/push-data';

  static uploadRawFile = (body: {
    googleAccessToken: string;
    fileUrl: string;
    folderId: string;
    fileName?: string;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/upload-raw`, body);
  };

  static pushDataToGoogleSlides = (body: {
    googleAccessToken: string;
    requests: any[];
    presentationId: string;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/update-presentation`, body);
  };

  static pushDataToGoogleSheets = (body: {
    googleAccessToken: string;
    spreadsheetId: string;
    text: string;
    sheetName: string;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/push-data-to-sheet`, body);
  };
}
